import { createFileRoute } from "@tanstack/react-router";
import { WithErrorBoundary } from "../../../hoc/with-error-boundary";
import { withPermissionCheck } from "../../../hoc/with-permission-check";
import { CatalogsCreateView } from "../../../views/app/catalog/catalogs/create/catalogs-create-view";

interface CatalogSearchParams {
  createdCatalogId: string;
  step: number;
}

export const Route = createFileRoute("/_main/app/catalogs/create")({
  validateSearch: (search: Record<string, unknown>): CatalogSearchParams => {
    return { createdCatalogId: (search?.createdCatalogId as string) || "", step: Number(search?.step ?? 0) };
  },
  component: () => WithErrorBoundary({ Component: withPermissionCheck({ Component: CatalogsCreateView }) }),
});
